"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_modal_1 = __importDefault(require("react-modal"));
var react_redux_1 = require("react-redux");
var EditImageModal_1 = __importDefault(require("./EditImageModal"));
var GalleryImage_1 = __importDefault(require("./GalleryImage"));
var isImageMetadataSuccess_1 = require("../utils/isImageMetadataSuccess");
var mediasSlice_1 = require("../state/mediasSlice");
var modalCustomStyles = {
    overlay: {
        zIndex: 1031,
        background: 'rgba(0,0,0,0.3)',
    },
    content: {
        width: '100vw',
        height: '100vh',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: 'none',
        borderRadius: '0',
        padding: '0',
        overflow: 'hidden',
        background: 'rgba(0,0,0,0.3)',
    },
};
function FullImage(props) {
    var containerSize = props.containerSize, imageCroppingAllowed = props.imageCroppingAllowed, imageRotationAllowed = props.imageRotationAllowed, isEditModeEnabled = props.isEditModeEnabled, imageId = props.imageId, _a = props.showBoundingBoxLabel, showBoundingBoxLabel = _a === void 0 ? false : _a, showBoundingBox = props.showBoundingBox, modalParentElementSelector = props.modalParentElementSelector, angularJsDependencies = props.angularJsDependencies, adId = props.adId, openMediaGalleryModal = props.openMediaGalleryModal, closeMediaGalleryModal = props.closeMediaGalleryModal, showImageActionIcons = props.showImageActionIcons, isHovered = props.isHovered, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, isModalOpen = props.isModalOpen, isClickable = props.isClickable, domain = props.domain, automationListsPermission = props.automationListsPermission, handleImageDeletion = props.handleImageDeletion, handleImageTransformations = props.handleImageTransformations;
    var selectedMediaId = (0, react_redux_1.useSelector)(function (state) { return (0, mediasSlice_1.selectedMediaIdSelector)(state, adId); });
    var selectedImageMetadata = (0, react_redux_1.useSelector)(function (state) { return (0, mediasSlice_1.imageMetadataSelector)(state, adId, selectedMediaId); });
    var _b = __read((0, react_1.useState)(false), 2), imageEditModalIsOpen = _b[0], setImageEditModalIsOpen = _b[1];
    var openImageEditModal = function (e) {
        setImageEditModalIsOpen(true);
        e.stopPropagation();
    };
    var closeImageEditModal = function () { return setImageEditModalIsOpen(false); };
    var onImageDeleteIconClick = function (e) {
        if (handleImageDeletion) {
            handleImageDeletion(selectedMediaId);
            e.stopPropagation();
        }
    };
    var searchImage = function (e) {
        if (selectedImageMetadata && (0, isImageMetadataSuccess_1.isImageMetadataSuccess)(selectedImageMetadata) && angularJsDependencies) {
            // [INFO] to be removed when switching to react-router
            window.open(angularJsDependencies.href('app.assignment.search', {
                text: "imagesInfo.content.phash.value: ".concat(selectedImageMetadata.phash),
            }));
            e.stopPropagation();
        }
    };
    (0, react_1.useEffect)(function () {
        modalParentElementSelector && react_modal_1.default.setAppElement(modalParentElementSelector);
        var close = function (e) {
            if (e.key === 'Escape') {
                closeMediaGalleryModal && closeMediaGalleryModal(e);
                closeImageEditModal();
            }
        };
        window.addEventListener('keydown', close);
        return function () { return window.removeEventListener('keydown', close); };
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(GalleryImage_1.default, { imageId: imageId, adId: adId, type: "fullImage", containerSize: containerSize, showFailedToDownloadImageText: true, showBoundingBox: showBoundingBox, showBoundingBoxLabel: showBoundingBoxLabel, showImageActionIcons: showImageActionIcons, isHovered: isHovered, isModalOpen: isModalOpen, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, isClickable: isClickable, imageActionIconsProps: {
                isEditModeEnabled: isEditModeEnabled,
                imageCroppingAllowed: imageCroppingAllowed,
                imageRotationAllowed: imageRotationAllowed,
                onImageDeleteIconClick: onImageDeleteIconClick,
                openImageEditModal: openImageEditModal,
                openMediaGalleryModal: openMediaGalleryModal,
                searchImage: searchImage,
            }, domain: domain, automationListsPermission: automationListsPermission }),
        react_1.default.createElement(react_modal_1.default, { isOpen: imageEditModalIsOpen, style: modalCustomStyles, portalClassName: "eva-edit-image-modal-window", bodyOpenClassName: "modal-open", closeTimeoutMS: 150, shouldCloseOnEsc: false },
            react_1.default.createElement(EditImageModal_1.default, { adId: adId, imageCroppingAllowed: imageCroppingAllowed, imageRotationAllowed: imageRotationAllowed, closeModal: closeImageEditModal, handleImageTransformations: handleImageTransformations }))));
}
exports.default = FullImage;
